import { NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CurrencyInputDirective } from '@zero/shared/ui-directives';
import { IconComponent, IconName } from '../icon/icon.component';

@Component({
  selector: 'web-design-system-input',
  imports: [FormsModule, IconComponent, CurrencyInputDirective, NgTemplateOutlet],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent implements OnChanges {
  @ViewChild('input') public input: ElementRef;

  @Input() public type: 'text' | 'password' | 'number' = 'text';
  @Input() public label: string;
  @Input() public isValid?: boolean;
  @Input() public value: string;
  @Input() public error?: string;
  @Input() public fixedLabel?: string;
  @Input() public disabled?: boolean;
  @Input() public autocomplete?: boolean;
  @Input() public focus?: boolean;
  @Input() public icon?: IconName;
  @Input() public isCurrency = false;
  @Input() public labelSize?: 'small' | 'base';

  @Output() public valueChange = new EventEmitter<string>();
  @Output() public handleBlur = new EventEmitter<string>();

  public isPasswordVisible = false;

  ngOnChanges(changes: SimpleChanges): void {
    changes['focus']?.currentValue && this.input.nativeElement.focus();
  }
}
